<script>
export default {
  components: {},
  props: {
    img: { type: String, required: true },
    title: { type: String, required: true },
    unitLong: { type: String, required: true },
    unitShort: { type: String, required: true },
    currentReading: { type: String, required: true },
    minReading: { type: String, required: true },
    maxReading: { type: String, required: true },
    remReading: { type: String, required: false, default: '' },
    awakeReading: { type: String, required: false, default: '' },
    currentText: { type: String, required: true },
    minText: { type: String, required: true },
    maxText: { type: String, required: true },
    remText: { type: String, required: false, default: '' },
    awakeText: { type: String, required: false, default: '' },
    resultText: { type: String, required: true },
    status: { type: Boolean, required: true },
    weeklyAvg: { type: [String, Number], required: false, default: '' },
    showDetails: { type: Boolean, required: true },
  },
  data() {
    return {
      currHrs: '',
      currMins: '',
      minHrs: '',
      minMins: '',
      maxHrs: '',
      maxMins: '',
      remHrs: '',
      remMins: '',
      awakeHrs: '',
      awakeMins: '',
      weeklyAvgHrs: '',
      weeklyAvgMins: '',
    }
  },
  mounted() {
    if (this.title === 'Sleep') {
      let readingArr = this.currentReading.split(':')
      this.currHrs = readingArr[0]
      this.currMins = readingArr[1] || '0'

      readingArr = this.minReading.split(':')
      this.minHrs = readingArr[0]
      this.minMins = readingArr[1] || '0'

      readingArr = this.maxReading.split(':')
      this.maxHrs = readingArr[0]
      this.maxMins = readingArr[1] || '0'

      readingArr = this.remReading.split(':')
      this.remHrs = readingArr[0]
      this.remMins = readingArr[1] || '0'

      readingArr = this.awakeReading.split(':')
      this.awakeHrs = readingArr[0]
      this.awakeMins = readingArr[1] || '0'

      readingArr = this.weeklyAvg.split(':')
      this.weeklyAvgHrs = readingArr[0]
      this.weeklyAvgMins = readingArr[1] || '0'
    }
  },
}
</script>

<template>
  <v-col :v-if="status" cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
    <div :class="$style.cardOuter">
      <v-card :class="$style.cardStyle" outlined>
        <div>
          <v-row :class="$style.cardTitle" class="mb-1">
            <v-img
              :class="$style.cardImg"
              height="24"
              width="32"
              contain
              :src="img"
            ></v-img>
            <v-col :class="$style.cardHeader">
              <p :class="$style.cardTitleText">{{ title }}</p>
            </v-col>
          </v-row>
          <div v-if="currentReading">
            <div>
              <div :class="$style.currentRow">
                <p :class="$style.currentText">{{ currentText }}</p>
                <span v-if="title !== 'Sleep'" :class="$style.currentReading">{{
                  currentReading
                }}</span>
                <span v-if="title !== 'Sleep'" :class="$style.shortUnit">{{
                  unitShort
                }}</span>
                <span v-if="title === 'Sleep'" :class="$style.currentReading">{{
                  currHrs
                }}</span>
                <span v-if="title === 'Sleep'" :class="$style.shortUnit"
                  >H</span
                >
                <span v-if="title === 'Sleep'" :class="$style.currentReading">
                  {{ currMins }}</span
                >
                <span v-if="title === 'Sleep'" :class="$style.shortUnit"
                  >M</span
                >
              </div>
            </div>
            <div v-if="showDetails" :class="$style.minMaxRow">
              <div :class="$style.currentRow">
                <p v-if="title !== 'Sleep'" :class="$style.minMaxText">{{
                  minText
                }}</p>
                <span v-if="title !== 'Sleep'" :class="$style.minMaxReadings">{{
                  minReading
                }}</span>
                <span
                  v-if="title !== 'Sleep' && title !== 'Blood Pressure'"
                  :class="$style.minMaxUnit"
                  >{{ unitShort }}</span
                >
              </div>
              <div :class="$style.currentRow">
                <p v-if="title !== 'Sleep'" :class="$style.minMaxText">{{
                  maxText
                }}</p>

                <span v-if="title !== 'Sleep'" :class="$style.minMaxReadings">{{
                  maxReading
                }}</span>
                <span
                  v-if="title !== 'Sleep' && title !== 'Blood Pressure'"
                  :class="$style.minMaxUnit"
                  >{{ unitShort }}</span
                >
              </div>
              <div v-if="title === 'Sleep'" :class="$style.currentRow"> </div>
            </div>
          </div>
          <div v-if="currentReading === ''" :class="$style.noDataImg">
            <v-img
              height="132"
              width="173"
              :class="{ 'mt-12': currentReading === '' && weeklyAvg === '' }"
              contain
              :src="require('@assets/images/safehaven/dashboard/no-data.png')"
            ></v-img>
          </div>
        </div>
      </v-card>
    </div>
  </v-col>
</template>

<style lang="scss" module>
@import '@design';
.cardStyle {
  min-height: 250px;
  padding: 30px !important;
  text-align: center;
  border-radius: 9px !important;
  box-shadow: 0 0 6px rgba(146, 191, 231, 0.6);
}
.cardStyle p {
  margin-bottom: 0 !important;
}

.cardOuter {
  padding: 20px;
}

.cardTitle {
  display: flex;
  align-items: center;
}
.cardImg {
  left: 12px;
  flex: 1;
}
.cardHeader {
  flex: 5;
}

.cardTitleText {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  text-align: left;
  letter-spacing: 0;
}

.cardSubTitleText {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #a5abb3;
  text-align: left;
  letter-spacing: 0;
}
.currentRow {
  justify-content: center;
}
.currentText {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0;
}

.currentReading {
  font-size: 44px;
  font-weight: 400;
  line-height: 60px;
  text-align: center;
  letter-spacing: -0.30000001192092896px;
}

.shortUnit {
  font-size: 24px;
  font-weight: 400;
  line-height: 18px;
  color: #a5abb3;
  letter-spacing: 0;
}

.minMaxRow {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}

.minMaxText {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #000;
  text-align: center;
  letter-spacing: 0;
}

.minMaxReadings {
  font-size: 22px;
  font-weight: 400;
  line-height: 33px;
  text-align: center;
  letter-spacing: 0;
}

.minMaxUnit {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #a5abb3;
  text-align: center;
  letter-spacing: 0;
}
.divider {
  height: 2px;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #d1dfeb;
}
.resultText {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #000;
  text-align: center;
  letter-spacing: 0;
}

.noDataImg {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 132px;
}
.comingSoonText {
  font-size: 22px;
  font-weight: 500;
  text-align: center;
}

@media screen and (max-width: 1600px) {
  .cardStyle {
    padding: 30px 20px !important;
  }
}

@media screen and (max-width: 959px) {
  .cardStyle {
    padding: 30px !important;
  }
}
@media screen and (max-width: 479px) {
  .cardOuter {
    padding: 10px;
  }
  .cardStyle {
    padding: 30px !important;
  }
}
</style>
